import React from 'react'
import ReactPlayerLoader  from '@brightcove/react-player-loader';

const ArticleV2VideoBrightcove = () => {
    return (
        <div className='bc-wrapper'>
            <ReactPlayerLoader videoId="6328842741112" accountId="6181993448001"/>
            <style jsx>{`
                .bc-wrapper :global(.video-js) {
                    margin-bottom: 20px;
                    width: 100%;
                    height: 0;
                    padding-bottom: 56.25%;
                }
            `}</style>
        </div>
    )
}

export default ArticleV2VideoBrightcove